module.exports = __webpack_public_path__ + "img/mingzhi_icon_01.19eefbd9.png";